import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ArrowLeft, Database, ShieldCheck, Loader2 } from 'lucide-react';
import { archiveConfig } from './archiveApi';

export const ArchiveShell = ({ title, readOnly = false, children }) => {
  const [status, setStatus] = useState('loading');
  useEffect(() => {
    let active = true;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, archiveConfig())
      .then(({ data }) => { if (active) setStatus(data.is_admin || data.role === 'admin' ? 'allowed' : 'denied'); })
      .catch(() => { if (active) setStatus('denied'); });
    return () => { active = false; };
  }, []);
  return <div className="min-h-screen bg-slate-50 text-slate-800" data-testid="archive-workspace">
    <header className="border-b bg-white"><div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-8">
      <Link to="/dashboard" className="flex items-center gap-2 font-heading font-bold" data-testid="archive-back-crm"><ArrowLeft className="h-4 w-4" /><Database className="h-5 w-5 text-blue-700" />Officium Connect</Link>
      <span className={`inline-flex items-center gap-2 text-xs font-semibold ${readOnly ? 'text-emerald-700' : 'text-slate-500'}`} data-testid="archive-workspace-mode"><ShieldCheck className="h-4 w-4" />{readOnly ? 'BACKUP PREVIEW · READ ONLY' : 'ADMIN · DATA SAFETY'}</span>
    </div></header>
    <main className="mx-auto max-w-7xl px-4 py-8 sm:px-8 sm:py-10">
      <h1 className="mb-8 font-heading text-3xl font-bold sm:text-4xl" data-testid="archive-page-title">{title}</h1>
      {status === 'loading' ? <p role="status" className="flex items-center gap-2" data-testid="archive-access-loading"><Loader2 className="h-4 w-4 animate-spin" />Checking access…</p> : status === 'denied' ? <p role="alert" className="text-red-700" data-testid="archive-access-denied">Administrator access is required.</p> : children}
    </main>
  </div>;
};